// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import usersPlusIcon from "@/assets/icons/users-plus.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type UsersPlusIconProps = Omit<IconProps, "name">;

export function UsersPlusIcon(props: UsersPlusIconProps): React.ReactNode {
  return <Icon name={usersPlusIcon} {...props} />;
}
